<lib-gung-backend-filter-list [configService]="productListBackendConfigService"></lib-gung-backend-filter-list>
